import { render, staticRenderFns } from "./shopClose.vue?vue&type=template&id=407b9780&scoped=true&"
import script from "./shopClose.vue?vue&type=script&lang=js&"
export * from "./shopClose.vue?vue&type=script&lang=js&"
import style0 from "./shopClose.vue?vue&type=style&index=0&id=407b9780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407b9780",
  null
  
)

export default component.exports